import { type TextProps } from 'tamagui';
import { Text } from '@/components/text';

// The one page-title (h1) treatment: `headline` role, 32/36 Fraunces 600
// (tokens/typography.json), tracking -0.01em (about -0.3px at 32px). Larger
// hero moments use `display` via an explicit fontSize/lineHeight override.
export function Heading({ children, ...props }: TextProps) {
  return (
    <Text
      fontFamily="$heading"
      fontWeight="$semibold"
      fontSize="$headline"
      lineHeight="$headline"
      letterSpacing={-0.3}
      color="$color"
      {...props}
    >
      {children}
    </Text>
  );
}
